import { render } from "./ArtworksList.vue?vue&type=template&id=983e908c&scoped=true"
import script from "./ArtworksList.vue?vue&type=script&lang=js"
export * from "./ArtworksList.vue?vue&type=script&lang=js"

import "./ArtworksList.vue?vue&type=style&index=0&id=983e908c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983e908c"]])

export default __exports__